import type { AdaptiveCard } from '@/lib/notificationSend.ts';

/*
 * `icon:<name>` names a Fluent icon only Teams knows. Microsoft's renderer
 * loads it as an image, which the page's Content Security Policy blocks.
 */
export function withoutTeamsIcons(card: AdaptiveCard): AdaptiveCard {
  return JSON.parse(JSON.stringify(card), (key, value: unknown) =>
    key === 'iconUrl' && typeof value === 'string' && value.startsWith('icon:')
      ? undefined
      : value,
  ) as AdaptiveCard;
}
